// Copyright 2025, University of Maryland, All Rights Reserved
import { useMemo } from 'react'
import type { SchemaBuilderState } from '@/types/schema-builder'
import { validateSchemaGeneratorState } from '@/utils/schema/schema-utils'

export function useSchemaValidation(state: SchemaBuilderState) {
  return useMemo(() => {
    return validateSchemaGeneratorState(state)
  }, [state])
}
